<template>
  <div>
    <validation-observer ref="form">
      <form novalidate @submit.prevent="saveCourse">
        <mdb-modal side position="right" fullHeight direction="right" :show="modal" @close="close">
          <mdb-modal-header>
              <mdb-modal-title class="h4">Neuer Verlauf <span class="h6 d-flex mb-0"> {{ medication.grund }} </span></mdb-modal-title>
          </mdb-modal-header>
          <mdb-modal-body class="example-card scrollbar-blue thin">
            <validation-provider
              name="Medikament"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <mdb-select
                ref="medikament"
                id="medikament"
                outline
                v-model="medicine"
                placeholder="Medikament auswählen"
                validation
              />
            </validation-provider>

            <validation-provider
              name="Menge"
              rules="required|max:10"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <mdb-input
                outline
                v-model="form.Menge"
                label="Menge"
                name="Menge"
                :customValidation="validated"
                :isValid="valid"
                :invalidFeedback="errors[0]"
                validFeedback="sieht gut aus"
              />
            </validation-provider>

            <validation-provider
              name="Datum"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <mdb-date-picker
                v-model="datum"
                disabledFuture
                label="Datum"
                name="Datum"
                :option="optionDatePicker"
                :customValidation="validated"
                :isValid="valid"
                :invalidFeedback="errors[0]"
                validFeedback="sieht gut aus"
                outline
                @getValue="getPickersValue"
              />
            </validation-provider>

            <validation-provider
              name="Uhrzeit"
              rules="required"
              v-slot="{ errors, valid, invalid }"
              slim
            >
              <mdb-time-picker
                id="uhrzeit"
                v-model="uhrzeit"
                label="Uhrzeit"
                name="Uhrzeit"
                :hours-format="24"
                class="mb-0"
                outline
                :done-label="optionTimePicker.done"
                :closeLabel="optionTimePicker.cancel"
                :clearLabel="optionTimePicker.clear"
                @getValue="verifyValue"
              />
              <span v-if="valid" class="valid-feedback d-block">sieht gut aus</span>
              <span v-if="invalid" class="invalid-feedback d-block">{{ errors[0] }}</span>
            </validation-provider>

            <validation-provider
              name="Reaktion"
              rules="max:500"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <mdb-input
                type="textarea"
                outline
                v-model="form.Reaktion"
                label="Reaktion"
                name="Reaktion"
                :customValidation="validated"
                :isValid="valid"
                :invalidFeedback="errors[0]"
                validFeedback="sieht gut aus"
              />
            </validation-provider>
          </mdb-modal-body>
          <mdb-modal-footer>
              <mdb-btn color="grey lighten-1" @click.native="close">Zurück</mdb-btn>
              <mdb-btn
                color="primary"
                :disabled="loading"
                type="submit"
              >
                <template v-if="!loading">
                  Erstellen <mdb-icon icon="save" />
                </template>
                <template v-else>
                  <span
                    class="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Verladung
                </template>
              </mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </form>
    </validation-observer>
  </div>
</template>

<script>
  import {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbInput,
    mdbSelect,
    mdbDatePicker,
    mdbTimePicker,
    mdbIcon
  } from 'mdbvue';
  import utils from '@/mixins/Utils'

  export default {
    name: 'MedicineModal',
    mixins: [utils()],

    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn,
      mdbInput,
      mdbSelect,
      mdbDatePicker,
      mdbTimePicker,
      mdbIcon
    },

    props: {
      modalState: {
        type: Boolean,
        default: false,
      },
      medication: {
        type: Object,
        default: () => {},
      },
      medicine: {
        type: Array,
        default: () => [],
      }
    },

    data() {
      return {
        modal: false,
        loading: false,
        datum: new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        uhrzeit: new Date().getHours() + ":" + new Date().getMinutes(),
        form: {
          Key: 0,
          Medikament: 0,
          Menge: '',
          Datum: '',
          Reaktion: '',
          AenderungVon: '',
          AenderungAm: ''
        },
        defaultForm: {
          Key: 0,
          Medikament: 0,
          Menge: '',
          Datum: '',
          Reaktion: '',
          AenderungVon: '',
          AenderungAm: ''
        },
      }
    },

    computed: {
      selectedMedicine () {
        let response = this.medicine.find(option => {
          return option.selected === true
        })
        if (response) {
          return response.value
        }
        return ""
      }
    },

    watch: {
      modalState (v) {
        this.modal = v
      },
    },

    methods: {
      close () {
        this.$refs.form.reset()
        this.datum = new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        this.uhrzeit = new Date().getHours() + ":" + new Date().getMinutes(),
        this.form = Object.assign({}, this.defaultForm)
        this.$refs.medikament.inputText = null
        this.$refs.medikament.inputValue = null
        this.schichtOptions.find(option => {
          option.selected = option.index === 0 ? true : false
        })
        this.$emit('close')
      },

      save () {
        this.modal = false
        this.$emit('save')
      },

      getPickersValue (value) {
        if(value) {
          this.datum = value
        }
      },

      verifyValue() {
        const time = document.getElementById('uhrzeit')
        if(time) {
          if(this.uhrzeit === '' || this.uhrzeit === undefined) {
            time.classList.add('is-invalid')
            time.classList.remove('is-valid')
          }else {
            time.classList.add('is-valid')
            time.classList.remove('is-invalid')
          }
        }
      },

      saveCourse() {
        this.loading = true
        this.verifyValue()

        // select validation check
        this.$refs.medikament.validate()
        if(this.$refs.medikament.inputValue == null || this.$refs.medikament.inputValue == ""){
          this.loading = false
          return
        }

        this.$refs.form.validate().then(success => {
          if (!success) {
            this.loading = false
            return
          }
          this.form.Medikament = this.selectedMedicine

          this.form.Datum = this.formatDateY(this.datum)
          var userDate= new Date(this.form.Datum + ' ' + this.uhrzeit)
          this.form.AenderungAm =  this.serverDateFormat(userDate)
          this.form.Datum =  this.serverDateFormat(userDate)
          this.form.AenderungVon = this.loginUser.username
          this.form.Key = this.medication.id

          this.$http.post('BedarfsmedikationVerlauf', this.form)
            .then(res => {
              if(res.data) {
                this.$notify.success({message: 'Neuer Verlauf hinzugefügt', position: 'top right', closeButton: false, timeOut: 5000})
                this.close()
                this.save()
              }else {
                this.$notify.error({message: 'Fehler beim Hinzufügen eines neuen Verlaufs !!', position: 'top right', closeButton: false, timeOut: 5000})
              }
            })
            .finally(() => {
              this.loading = false
            })
        });
      }
    }
  }
</script>
